import React, { useState } from 'react';
import { Popover, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // or your routing library
// import ZoomIconImage from './path/to/your/zoom-icon'; // Update with your actual path
import ZoomIconImage from 'src/assets/zoom.svg';
import { UpgradeButton } from '../Payments/UpgradeButton';

const ZoomEncounterModal = ({ setShowZoomModal }) => {
  const [activePopover, setActivePopover] = useState(null);
  const navigate = useNavigate();

  // Get pro status
  const { currentPractitionerEntitlements } = useSelector(
    (state) => state?.practitionerState
  );
  const isAuraPro = currentPractitionerEntitlements?.plans?.some(
    (plan) => plan?.metadata?.type === 'pro'
  );

  // Check if zoom is integrated
  const isZoomIntegrated = !!localStorage.getItem('zoomAccessToken');
  // const isZoomIntegrated = false;

  // Tooltip handlers
  const handleShowUpgradeTooltip = (element) => {
    if (!isAuraPro) {
      setActivePopover(element);
    }
  };

  const handleHideUpgradeTooltip = () => {
    setActivePopover(null);
  };

  // Click handler for zoom icon
  const handleZoomIconClick = () => {
    if (!isAuraPro) {
      // Case 2: User is not pro - show upgrade tooltip (handled by popover)
      handleShowUpgradeTooltip('zoom');
      return;
    }

    if (isAuraPro && !isZoomIntegrated) {
      // Case 3: User is pro but not integrated - go to integrations
      navigate('/integrations');
      return;
    }

    if (isAuraPro && isZoomIntegrated) {
      // Case 1: User is pro and integrated - normal flow
      handleNormalZoomFlow();
    }
  };

  // Your normal zoom flow function
  const handleNormalZoomFlow = () => {
    setShowZoomModal(true);
  };

  // Render upgrade tooltip content
  const renderUpgradeTooltip = () => (
    <div
      onMouseEnter={() => handleShowUpgradeTooltip('zoom')}
      onMouseLeave={handleHideUpgradeTooltip}
    >
      <UpgradeButton
        text="Upgrade to access this feature"
        analyticsEvent="Clicked Zoom Encounter Button"
      />
    </div>
  );

  // Render the zoom icon based on conditions
  const renderZoomIcon = () => {
    if (isAuraPro && isZoomIntegrated) {
      // Case 1: Pro + Integrated - Normal flow with tooltip
      return (
        <Tooltip title="Add to live meeting" placement="topRight">
          <img
            src={ZoomIconImage}
            height={30}
            width={30}
            className="mr-1.5 cursor-pointer"
            onClick={handleZoomIconClick}
            alt="Zoom"
          />
        </Tooltip>
      );
    }

    // Case 2 & 3: Show icon for popover or navigation
    return (
      <img
        src={ZoomIconImage}
        height={30}
        width={30}
        className="mr-1.5 cursor-pointer opacity-50"
        onClick={handleZoomIconClick}
        onMouseEnter={() => {
          if (!isAuraPro) {
            handleShowUpgradeTooltip('zoom');
          }
        }}
        onMouseLeave={handleHideUpgradeTooltip}
        alt="Zoom"
      />
    );
  };

  return (
    <Popover
      content={renderUpgradeTooltip()}
      open={!isAuraPro && activePopover === 'zoom'}
      trigger="hover"
      placement="rightTop"
      mouseLeaveDelay={0.3}
      overlayInnerStyle={{ padding: '0px' }}
      align={{
        offset: [0, 0],
      }}
      onOpenChange={(visible) => {
        if (!visible) {
          handleHideUpgradeTooltip();
        }
      }}
    >
      {renderZoomIcon()}
    </Popover>
  );
};

export default ZoomEncounterModal;
